import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { isEmulatorEnv } from './utils/apiBase';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

//  EMULATOR MODE - uses the same detection as apiBase (env flag OR

// localhost auto-detect, never on Capacitor native). Previously this only
// honored the env flag, so when apiBase moved to auto-detection the REST
// calls went to the emulator while SDK auth/Firestore silently kept
// talking to PRODUCTION - a split-brain that corrupted test sessions.
// The global guard prevents double-connecting when both firebase modules
// (src/firebase.ts and src/services/firebase.ts) load - they share the
// same [DEFAULT] app, and connect*Emulator throws on a second call.
if (isEmulatorEnv() && !(globalThis as any).__pssEmulatorsConnected) {
  (globalThis as any).__pssEmulatorsConnected = true;
  try {
    console.log('🧪 [EMULATOR] Connecting Firebase SDK to local emulators');
    connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
    connectFirestoreEmulator(db, 'localhost', 8080);
    connectStorageEmulator(storage, 'localhost', 9199);
    connectFunctionsEmulator(functions, 'localhost', 5001);
  } catch (e) {
    console.warn('🧪 [EMULATOR] SDK connect skipped (already connected?):', e);
  }
}
